import { UploadTimeCalculator } from 'packages/core/files/UploadTimeCalculator';
import { fileSize, fileType, UNIT_MB } from 'common/services/FileService';
import { FileTooLargeException, InvalidFileTypeException } from 'packages/core/files/exceptions';
export var UploadStatus;
(function (UploadStatus) {
    UploadStatus["CREATED"] = "CREATED";
    UploadStatus["UPLOADING"] = "UPLOADING";
    UploadStatus["COMPLETE"] = "COMPLETE";
    UploadStatus["CANCELED"] = "CANCELED";
    UploadStatus["TIMED_OUT"] = "TIMED_OUT";
})(UploadStatus || (UploadStatus = {}));
var FileUpload = /** @class */ (function () {
    function FileUpload(file) {
        this.file = file;
        this.status = UploadStatus.CREATED;
        this.promise = null;
        this.progress = null;
        this.timer = new UploadTimeCalculator();
    }
    FileUpload.prototype.onUploadProgress = function (progressEvent) {
        this.progress = progressEvent;
        this.timer.total = progressEvent.total;
        this.timer.totalUploaded = progressEvent.loaded;
    };
    FileUpload.prototype.cancel = function () {
        this.promise.cancel();
        this.timer.stop();
        this.status = UploadStatus.CANCELED;
    };
    FileUpload.prototype.setTimedOut = function () {
        this.timer.stop();
        this.status = UploadStatus.TIMED_OUT;
    };
    FileUpload.prototype.validate = function (maxSize, filetypes) {
        var type = fileType(this.file).toLowerCase();
        var size = fileSize(this.file, UNIT_MB);
        if (size > maxSize) {
            throw (new FileTooLargeException());
        }
        if (!filetypes.includes(type)) {
            throw (new InvalidFileTypeException());
        }
        return true;
    };
    return FileUpload;
}());
export { FileUpload };
